// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.ag-theme-alpine .ag-header-row {
  color: black;
}

.ag-theme-alpine .ag-row-odd {
  background-color: #f5f5f5;
}

.aggridbasecomponent {
  width: 100%;
  height: 100%;
}

.userSetupPage .aggridbasecomponent {
  min-height: 20vh;
}

.ag-header-row-column-group {
  background: #f3f3f3;
  /* font-family: SF Pro Display; */
  font-family: var(--default-FontName);
}

.ag-header-viewport,
.ag-header-row {
  background: #ffffff;
}

.batchProcessList .ag-header-group-cell-label,
.batchProcessList .ag-header-cell-label {
  justify-content: center;
}

.batchProcessList .ag-header-viewport,
.batchProcessList .ag-header-row {
  background: #f5f5f5;
}

.ag-header-cell.ag-header-cell-sortable {
  border: 0px !important;
}

.ag-header-group-text {
  position: static;
  left: 5.93%;
  right: 5.93%;
  top: 0%;
  bottom: 0%;
  /* font-family: SF Pro Display; */
  font-family: var(--default-FontName);
  font-style: normal;
  font-size: var(--listHeaderFontSize);
  line-height: 1.53vh;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--listHeaderFontColor);
  flex: none;
  order: 0;
  align-self: center;
  margin: 10px 0px;
  margin: 0.52vw 0vw;
  font-weight: var(--header-FontWeight);
}

.ag-theme-alpine .ag-root-wrapper {
  border: none;

  box-shadow: inset 0px 1px 0px #d6d6d6;
  box-shadow: inset 0vw 0.05vw 0.05vw #d6d6d6;
  /* font-family: SF Pro Display; */
  font-family: var(--default-FontName);
}

.ag-header-container {
  /* font-family: SF Pro Display; */
  font-family: var(--default-FontName);
  color: aliceblue;
  font-size: 0.625vw;
  font-size: 0.73vw;
  width: 100%;
}

.ag-row-hover,
.ag-row-selected {
  background-color: #ececec !important;
}

.ag-theme-alpine .ag-checkbox-input-wrapper.ag-checked::after {
  color: black;
}

[col-id='edit'] {
  justify-content: flex-end;
}

.ag-theme-alpine .ag-row {
  border-width: 0px;
  /* background-color: white; */
}

.ag-header-cell-text,
.ag-header-group-cell,
.gridCellFlexBox.customHeader {
  /* color: #303030; */
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--listHeaderFontWeight);
  font-size: var(--listHeaderFontSize);
  line-height: 21px;
  color: var(--listHeaderFontColor);
}
.buttonCell {
  padding: 10px;
}

.ag-theme-alpine .ag-root-wrapper {
  border: 0px;
}

.ag-header-container {
  font-size: 0.729vw;
}

.ag-theme-alpine {
  /* font-size: 0.875rem; */
  height: 100%;
  width: auto;
  /* margin-top: 0.98vw; */
  overflow: auto;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  /* color: var(--default-FontColour); */
  border-radius: 5px;
}

.ag-theme-alpine .ag-header {
  background-color: white;
}

.ag-theme-alpine .ag-popup {
  height: 0;
}

.ag-theme-alpine .ag-column-drop-wrapper > div:first-child {
  border-top: 1px dashed black;
  border-bottom: 1px dashed black;
  color: #000;
}

.ag-theme-alpine .ag-header-cell-label .ag-header-icon.ag-sort-order {
  display: none;
}

.ag-react-container {
  width: 100%;
}

.MuiGrid-container {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
}

.userSetupPage .roleSetup .MuiGrid-container {
  align-items: unset;
}

.ag-theme-alpine .ag-popup-child:not(.ag-tooltip-custom) {
  border-radius: 4px;
  /* background-color: var(--gridbgcolor); */
}

.ag-theme-alpine .ag-react-container .MuiInputBase-root {
  padding: 4px;
}

.ag-theme-alpine .ag-header {
  /* border-bottom: solid 1.5px var(--RowBorder-Colour); */
  border-bottom: 1px solid #e3e3e3;
}

.NoColumns.ag-theme-alpine .ag-header {
  border-bottom: none !important;
}

.custom-loading-overlay {
  font-family: var(--default-FontName);
}

.ag-cell-value {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: 400;
  font-size: var(--default-FontSize);
  line-height: 21pxvw;
  color: #000000;
}

.gridLinkclass {
  text-decoration-line: none;
}

.ag-theme-alpine .ag-cell {
  /* line-height: 2.604vw; */
  line-height: 4.804vh;
}

.ag-theme-alpine .ag-ltr .ag-row.ag-cell-last-left-pinned,
.ag-theme-alpine .ag-ltr .ag-cell:not(.ag-cell-focus).ag-cell-last-left-pinned {
  border-right: 0px solid #bdc3c7;
}

.ag-theme-alpine
  .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(
    .ag-cell-range-single-cell
  ) {
  border-right: 0px solid #bdc3c7;
}

span.ag-header-icon.ag-header-cell-menu-button {
  opacity: 1;
}

.ag-theme-alpine .MuiPaper-rounded {
  margin-top: 48px;
  border-radius: 4px;
}

span.ag-paging-description {
  line-height: 16px;
  margin-top: -1px;
}

.ag-paging-panel {
  justify-content: space-between;
  /* padding-top: 10px; */
}

span.ag-paging-page-summary-panel {
  margin-right: unset;
}

span.ag-paging-row-summary-panel {
  margin-left: unset;
}

.ag-pinned-left-header {
  border-right: none;
}

.ag-pinned-right-header {
  border-left: none;
}

.ag-cell.ag-cell-first-right-pinned {
  border-left: none;
}

.gridCellFlexBox {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 2px;
}

.gridCellFlexBox.justifyCentre {
  justify-content: center;
}

.header_justifyCentre .ag-header-cell-label {
  justify-content: center;
}

.gridCellFlexBox .gridCellDisplayData {
  overflow: hidden;
  text-overflow: ellipsis;
}

.gridCellFlexBox .gridCellDisplayData .highlightPayment {
  color: red;
}
.gridCellFlexBox .divOfHoverTitle .gridCellDisplayData {
  display: block;
}
.gridCellFlexBox .divOfHoverTitle.disabled .gridCellDisplayData {
  color: var(--button-disabled-color);
}
.gridCellFlexBox .editStage {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}
.gridCellFlexBox .editStage.disabled {
  cursor: default;
  pointer-events: none;
}
.gridCellFlexBox .divOfHoverTitle {
  width: 100%;
}
.gridCellFlexBox .editStage .gridCellDisplayData {
  font-weight: var(--sub-header-FontWeight);
  color: var(--popupTItleColor);
  fill: var(--popupTItleColor);
}
.gridCellFlexBox .editStage.disabled .gridCellDisplayData {
  color: var(--button-disabled-color) !important;
}
.gridCellFlexBox .editStage.disabled path {
  fill: var(--button-disabled-color) !important;
}
.gridCellFlexBox .attachmentImg {
  height: 30px;
  width: 20px;
}

.gridCellFlexBox .statusIndicator {
  height: 20px;
  width: 20px;
}

.gridCellFlexBox .statusIndicator.eyeIcon {
  width: unset;
  height: unset;
}

.gridCellFlexBox .reactSvgDiv div {
  height: 100%;
  display: flex;
  align-items: center;
}

.gridCellFlexBox.customHeader p {
  margin: 0px;
}

.gridCellFlexBox.customHeader .headerWithIcon {
  display: flex;
  gap: 20px;
  align-items: center;
}

.gridCellFlexBox.customHeader .headerWithIcon .reactSvgDiv,
.gridCellFlexBox.customHeader .headerWithIcon div {
  height: 16px;
  width: 16px;
}

.gridCellDisplayData .ocrActions {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.gridCellDisplayData .ocrActions .button.MuiButton-root {
  height: 35px;
  padding: 5px 15px;
  /* as common button padding */
}

.gridCellFlexBox .checkboxControl .MuiCheckbox-root {
  padding-left: 0px;
}

.gridCellFlexBox .checkboxControl svg {
  width: 0.8em;
  height: 0.8em;
  fill: var(--button-color);
}

.gridCellFlexBox .reactSvgDiv.customCellIcon {
  cursor: pointer;
}

.gridCellFlexBox .reactSvgDiv.customCellIcon.cameraIcon div svg {
  width: var(--gridCellIconWidth);
}

.ag-header-cell-sortable .ag-header-cell-comp-wrapper {
  cursor: pointer;
}

.ag-header-cell-sortable {
  cursor: default;
}

.userDataSection
  .roleSetup
  .aggridbasecomponent
  .gridCellFlexBox
  .statusIndicator.reactSvgDiv.disableAction {
  cursor: default;
}

.gridCellFlexBox .reactSvgDiv.disableAction svg path {
  fill: var(--button-disabled-color);
}

.gridCellFlexBox .reactSvgDiv.disableAction {
  cursor: default;
}
.gridCellFlexBox .editStage.enabled {
  cursor: pointer;
}
.gridCellFlexBox .button.btn--secondary,
.gridCellFlexBox .button.btn--secondary.MuiButton-root:hover {
  margin: 0px;
}
.gridCellFlexBox.highlightPayment .currencyImage path {
  /* when need to change color of svg icon can give fill property here with color code */
}

.aggridbasecomponent .ag-theme-alpine .ag-cell.ag-cell-first-right-pinned {
  border-left: none;
}

.aggridbasecomponent .ag-pinned-right-header {
  border-left: none;
}

.aggridbasecomponent .ag-pinned-left-header {
  border-right: none;
}

.aggridbasecomponent [col-id='edit'] .morevert-icon {
  padding-left: 0px;
}

/* .attachmentGrid .ag-theme-alpine div {
  height: 90%;
} */

.ag-ltr .ag-cell-focus:not(.ag-cell-range-selected),
.ag-ltr .ag-cell,
.ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within {
  border: unset;
}

.userDataSection .roleSetup .ag-header-viewport,
.userDataSection .roleSetup .ag-header-row,
.userDataSection .roleSetup .ag-theme-alpine .ag-header {
  background: unset;
}

.userDataSection .roleSetup .aggridbasecomponent .ag-root-wrapper {
  background-color: unset;
}

/* .userDataSection .roleSetup .ag-body-horizontal-scroll-viewport {
  overflow-x: hidden;
} */

.userDataSection .roleSetup .aggridbasecomponent .ag-row {
  background: unset;
}

.userDataSection
  .roleSetup
  .aggridbasecomponent
  .gridCellFlexBox
  .statusIndicator {
  cursor: pointer;
}

.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(
    .ag-cell-range-single-cell
  ) {
  border-right: none;
}
.ag-paging-panel .ag-paging-page-size {
  display: none;
}
.gridCellFlexBox .attachmentFileNameDiv {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gridCellFlexBox .gridCellDisplayData.attachmentFileNameDiv .fileName {
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--header-FontWeight);
  color: var(--TitleBar-IconColour);
}
.gridCellFlexBox
  .gridCellDisplayData.attachmentFileNameDiv
  .fileName.downloadable {
  text-decoration: underline;
  cursor: pointer;
}
.gridCellFlexBox .gridCellDisplayData.hyperlink {
  text-decoration: underline;
  cursor: pointer;
}
.gridCellFlexBox .gridCellDisplayData.primaryColor {
  color: var(--button-color);
}
.gridCellFlexBox .gridCellDisplayData.disableAction {
  color: var(--listHeaderFontColor);
  text-decoration: none;
  cursor: default;
}
.aggridbasecomponent .ag-checkbox-input-wrapper::after,
.aggridbasecomponent
  .ag-theme-alpine
  .ag-checkbox-input-wrapper.ag-checked::after {
  color: var(--button-color);
}
.aggridbasecomponent .ag-checkbox-input-wrapper:focus-within,
.aggridbasecomponent .ag-checkbox-input-wrapper:active {
  box-shadow: none;
}
.debtorReview_addNote {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
span.gridCellDisplayData.addNote {
  color: var(--secondary-FontColour);
  font-size: var(--default-FontSize);
  font-weight: var(--header-FontWeight);
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/grid/Grid.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,UAAU;EACV,iCAAiC;EACjC,oCAAoC;EACpC,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;EACjC,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,YAAY;;EAEZ,qCAAqC;EACrC,2CAA2C;EAC3C,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;EAGE,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,oCAAoC;EACpC,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,cAAc;EACd,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wDAAwD;EACxD,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,8CAA8C;AAChD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,WAAW;AACb;AACA;EACE,sFAAsF;AACxF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;;;EAGE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;AACjB;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,qCAAqC;AACvC","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.ag-theme-alpine .ag-header-row {\n  color: black;\n}\n\n.ag-theme-alpine .ag-row-odd {\n  background-color: #f5f5f5;\n}\n\n.aggridbasecomponent {\n  width: 100%;\n  height: 100%;\n}\n\n.userSetupPage .aggridbasecomponent {\n  min-height: 20vh;\n}\n\n.ag-header-row-column-group {\n  background: #f3f3f3;\n  /* font-family: SF Pro Display; */\n  font-family: var(--default-FontName);\n}\n\n.ag-header-viewport,\n.ag-header-row {\n  background: #ffffff;\n}\n\n.batchProcessList .ag-header-group-cell-label,\n.batchProcessList .ag-header-cell-label {\n  justify-content: center;\n}\n\n.batchProcessList .ag-header-viewport,\n.batchProcessList .ag-header-row {\n  background: #f5f5f5;\n}\n\n.ag-header-cell.ag-header-cell-sortable {\n  border: 0px !important;\n}\n\n.ag-header-group-text {\n  position: static;\n  left: 5.93%;\n  right: 5.93%;\n  top: 0%;\n  bottom: 0%;\n  /* font-family: SF Pro Display; */\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-size: var(--listHeaderFontSize);\n  line-height: 1.53vh;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--listHeaderFontColor);\n  flex: none;\n  order: 0;\n  align-self: center;\n  margin: 10px 0px;\n  margin: 0.52vw 0vw;\n  font-weight: var(--header-FontWeight);\n}\n\n.ag-theme-alpine .ag-root-wrapper {\n  border: none;\n\n  box-shadow: inset 0px 1px 0px #d6d6d6;\n  box-shadow: inset 0vw 0.05vw 0.05vw #d6d6d6;\n  /* font-family: SF Pro Display; */\n  font-family: var(--default-FontName);\n}\n\n.ag-header-container {\n  /* font-family: SF Pro Display; */\n  font-family: var(--default-FontName);\n  color: aliceblue;\n  font-size: 0.625vw;\n  font-size: 0.73vw;\n  width: 100%;\n}\n\n.ag-row-hover,\n.ag-row-selected {\n  background-color: #ececec !important;\n}\n\n.ag-theme-alpine .ag-checkbox-input-wrapper.ag-checked::after {\n  color: black;\n}\n\n[col-id='edit'] {\n  justify-content: flex-end;\n}\n\n.ag-theme-alpine .ag-row {\n  border-width: 0px;\n  /* background-color: white; */\n}\n\n.ag-header-cell-text,\n.ag-header-group-cell,\n.gridCellFlexBox.customHeader {\n  /* color: #303030; */\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--listHeaderFontWeight);\n  font-size: var(--listHeaderFontSize);\n  line-height: 21px;\n  color: var(--listHeaderFontColor);\n}\n.buttonCell {\n  padding: 10px;\n}\n\n.ag-theme-alpine .ag-root-wrapper {\n  border: 0px;\n}\n\n.ag-header-container {\n  font-size: 0.729vw;\n}\n\n.ag-theme-alpine {\n  /* font-size: 0.875rem; */\n  height: 100%;\n  width: auto;\n  /* margin-top: 0.98vw; */\n  overflow: auto;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  /* color: var(--default-FontColour); */\n  border-radius: 5px;\n}\n\n.ag-theme-alpine .ag-header {\n  background-color: white;\n}\n\n.ag-theme-alpine .ag-popup {\n  height: 0;\n}\n\n.ag-theme-alpine .ag-column-drop-wrapper > div:first-child {\n  border-top: 1px dashed black;\n  border-bottom: 1px dashed black;\n  color: #000;\n}\n\n.ag-theme-alpine .ag-header-cell-label .ag-header-icon.ag-sort-order {\n  display: none;\n}\n\n.ag-react-container {\n  width: 100%;\n}\n\n.MuiGrid-container {\n  width: 100%;\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n}\n\n.userSetupPage .roleSetup .MuiGrid-container {\n  align-items: unset;\n}\n\n.ag-theme-alpine .ag-popup-child:not(.ag-tooltip-custom) {\n  border-radius: 4px;\n  /* background-color: var(--gridbgcolor); */\n}\n\n.ag-theme-alpine .ag-react-container .MuiInputBase-root {\n  padding: 4px;\n}\n\n.ag-theme-alpine .ag-header {\n  /* border-bottom: solid 1.5px var(--RowBorder-Colour); */\n  border-bottom: 1px solid #e3e3e3;\n}\n\n.NoColumns.ag-theme-alpine .ag-header {\n  border-bottom: none !important;\n}\n\n.custom-loading-overlay {\n  font-family: var(--default-FontName);\n}\n\n.ag-cell-value {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: 400;\n  font-size: var(--default-FontSize);\n  line-height: 21pxvw;\n  color: #000000;\n}\n\n.gridLinkclass {\n  text-decoration-line: none;\n}\n\n.ag-theme-alpine .ag-cell {\n  /* line-height: 2.604vw; */\n  line-height: 4.804vh;\n}\n\n.ag-theme-alpine .ag-ltr .ag-row.ag-cell-last-left-pinned,\n.ag-theme-alpine .ag-ltr .ag-cell:not(.ag-cell-focus).ag-cell-last-left-pinned {\n  border-right: 0px solid #bdc3c7;\n}\n\n.ag-theme-alpine\n  .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(\n    .ag-cell-range-single-cell\n  ) {\n  border-right: 0px solid #bdc3c7;\n}\n\nspan.ag-header-icon.ag-header-cell-menu-button {\n  opacity: 1;\n}\n\n.ag-theme-alpine .MuiPaper-rounded {\n  margin-top: 48px;\n  border-radius: 4px;\n}\n\nspan.ag-paging-description {\n  line-height: 16px;\n  margin-top: -1px;\n}\n\n.ag-paging-panel {\n  justify-content: space-between;\n  /* padding-top: 10px; */\n}\n\nspan.ag-paging-page-summary-panel {\n  margin-right: unset;\n}\n\nspan.ag-paging-row-summary-panel {\n  margin-left: unset;\n}\n\n.ag-pinned-left-header {\n  border-right: none;\n}\n\n.ag-pinned-right-header {\n  border-left: none;\n}\n\n.ag-cell.ag-cell-first-right-pinned {\n  border-left: none;\n}\n\n.gridCellFlexBox {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.gridCellFlexBox.justifyCentre {\n  justify-content: center;\n}\n\n.header_justifyCentre .ag-header-cell-label {\n  justify-content: center;\n}\n\n.gridCellFlexBox .gridCellDisplayData {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.gridCellFlexBox .gridCellDisplayData .highlightPayment {\n  color: red;\n}\n.gridCellFlexBox .divOfHoverTitle .gridCellDisplayData {\n  display: block;\n}\n.gridCellFlexBox .divOfHoverTitle.disabled .gridCellDisplayData {\n  color: var(--button-disabled-color);\n}\n.gridCellFlexBox .editStage {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n.gridCellFlexBox .editStage.disabled {\n  cursor: default;\n  pointer-events: none;\n}\n.gridCellFlexBox .divOfHoverTitle {\n  width: 100%;\n}\n.gridCellFlexBox .editStage .gridCellDisplayData {\n  font-weight: var(--sub-header-FontWeight);\n  color: var(--popupTItleColor);\n  fill: var(--popupTItleColor);\n}\n.gridCellFlexBox .editStage.disabled .gridCellDisplayData {\n  color: var(--button-disabled-color) !important;\n}\n.gridCellFlexBox .editStage.disabled path {\n  fill: var(--button-disabled-color) !important;\n}\n.gridCellFlexBox .attachmentImg {\n  height: 30px;\n  width: 20px;\n}\n\n.gridCellFlexBox .statusIndicator {\n  height: 20px;\n  width: 20px;\n}\n\n.gridCellFlexBox .statusIndicator.eyeIcon {\n  width: unset;\n  height: unset;\n}\n\n.gridCellFlexBox .reactSvgDiv div {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.gridCellFlexBox.customHeader p {\n  margin: 0px;\n}\n\n.gridCellFlexBox.customHeader .headerWithIcon {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.gridCellFlexBox.customHeader .headerWithIcon .reactSvgDiv,\n.gridCellFlexBox.customHeader .headerWithIcon div {\n  height: 16px;\n  width: 16px;\n}\n\n.gridCellDisplayData .ocrActions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.gridCellDisplayData .ocrActions .button.MuiButton-root {\n  height: 35px;\n  padding: 5px 15px;\n  /* as common button padding */\n}\n\n.gridCellFlexBox .checkboxControl .MuiCheckbox-root {\n  padding-left: 0px;\n}\n\n.gridCellFlexBox .checkboxControl svg {\n  width: 0.8em;\n  height: 0.8em;\n  fill: var(--button-color);\n}\n\n.gridCellFlexBox .reactSvgDiv.customCellIcon {\n  cursor: pointer;\n}\n\n.gridCellFlexBox .reactSvgDiv.customCellIcon.cameraIcon div svg {\n  width: var(--gridCellIconWidth);\n}\n\n.ag-header-cell-sortable .ag-header-cell-comp-wrapper {\n  cursor: pointer;\n}\n\n.ag-header-cell-sortable {\n  cursor: default;\n}\n\n.userDataSection\n  .roleSetup\n  .aggridbasecomponent\n  .gridCellFlexBox\n  .statusIndicator.reactSvgDiv.disableAction {\n  cursor: default;\n}\n\n.gridCellFlexBox .reactSvgDiv.disableAction svg path {\n  fill: var(--button-disabled-color);\n}\n\n.gridCellFlexBox .reactSvgDiv.disableAction {\n  cursor: default;\n}\n.gridCellFlexBox .editStage.enabled {\n  cursor: pointer;\n}\n.gridCellFlexBox .button.btn--secondary,\n.gridCellFlexBox .button.btn--secondary.MuiButton-root:hover {\n  margin: 0px;\n}\n.gridCellFlexBox.highlightPayment .currencyImage path {\n  /* when need to change color of svg icon can give fill property here with color code */\n}\n\n.aggridbasecomponent .ag-theme-alpine .ag-cell.ag-cell-first-right-pinned {\n  border-left: none;\n}\n\n.aggridbasecomponent .ag-pinned-right-header {\n  border-left: none;\n}\n\n.aggridbasecomponent .ag-pinned-left-header {\n  border-right: none;\n}\n\n.aggridbasecomponent [col-id='edit'] .morevert-icon {\n  padding-left: 0px;\n}\n\n/* .attachmentGrid .ag-theme-alpine div {\n  height: 90%;\n} */\n\n.ag-ltr .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-ltr .ag-cell,\n.ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within {\n  border: unset;\n}\n\n.userDataSection .roleSetup .ag-header-viewport,\n.userDataSection .roleSetup .ag-header-row,\n.userDataSection .roleSetup .ag-theme-alpine .ag-header {\n  background: unset;\n}\n\n.userDataSection .roleSetup .aggridbasecomponent .ag-root-wrapper {\n  background-color: unset;\n}\n\n/* .userDataSection .roleSetup .ag-body-horizontal-scroll-viewport {\n  overflow-x: hidden;\n} */\n\n.userDataSection .roleSetup .aggridbasecomponent .ag-row {\n  background: unset;\n}\n\n.userDataSection\n  .roleSetup\n  .aggridbasecomponent\n  .gridCellFlexBox\n  .statusIndicator {\n  cursor: pointer;\n}\n\n.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(\n    .ag-cell-range-single-cell\n  ) {\n  border-right: none;\n}\n.ag-paging-panel .ag-paging-page-size {\n  display: none;\n}\n.gridCellFlexBox .attachmentFileNameDiv {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.gridCellFlexBox .gridCellDisplayData.attachmentFileNameDiv .fileName {\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--header-FontWeight);\n  color: var(--TitleBar-IconColour);\n}\n.gridCellFlexBox\n  .gridCellDisplayData.attachmentFileNameDiv\n  .fileName.downloadable {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.gridCellFlexBox .gridCellDisplayData.hyperlink {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.gridCellFlexBox .gridCellDisplayData.primaryColor {\n  color: var(--button-color);\n}\n.gridCellFlexBox .gridCellDisplayData.disableAction {\n  color: var(--listHeaderFontColor);\n  text-decoration: none;\n  cursor: default;\n}\n.aggridbasecomponent .ag-checkbox-input-wrapper::after,\n.aggridbasecomponent\n  .ag-theme-alpine\n  .ag-checkbox-input-wrapper.ag-checked::after {\n  color: var(--button-color);\n}\n.aggridbasecomponent .ag-checkbox-input-wrapper:focus-within,\n.aggridbasecomponent .ag-checkbox-input-wrapper:active {\n  box-shadow: none;\n}\n.debtorReview_addNote {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-items: center;\n  cursor: pointer;\n}\nspan.gridCellDisplayData.addNote {\n  color: var(--secondary-FontColour);\n  font-size: var(--default-FontSize);\n  font-weight: var(--header-FontWeight);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
